import { FC, useEffect, useRef } from "react";
import ErrorElement from "./ErrorElement";

const ErrorRouterElement: FC = () => {
    const isFirstRender = useRef(true);

    useEffect(() => {
        const reloadCountStr = sessionStorage.getItem("reloadCount") || 0;
        const reloadCount = Number(reloadCountStr);

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return undefined;
        }

        if (reloadCount < 3) {
            sessionStorage.setItem("reloadCount", String(reloadCount + 1));
            window.location.reload();
            return undefined;
        }

        return () => {
            sessionStorage.removeItem("reloadCount");
        };
    }, []);

    return <ErrorElement />;
};

export default ErrorRouterElement;
